import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import { Card } from '~/components/card';

type MentorBenefitsCardProps = {
  title: string;
  description: string;
};

export function MentorBenefitsCard({ title, description }: MentorBenefitsCardProps) {
  return (
    <Card
      alignItems='baseline'
      borderRadius='8px'
      boxShadow='md'
      display='flex'
      flexDir='row'
      gap='15px'
      position='relative'
      px={6}
      py={8}
      w={{ base: 'full', md: '544px' }}
    >
      <Box paddingTop='5px'>
        <CheckedIcon color='blue.500' height='32px' width='32px' />
      </Box>
      <Flex flexDirection='column' textAlign='left'>
        {title && (
          <Heading as='h3' color='blue.500' fontSize='24px' fontWeight='400' lineHeight='40px'>
            {title}
          </Heading>
        )}
        {description && <Text>{description}</Text>}
      </Flex>
    </Card>
  );
}
